module.exports = __webpack_public_path__ + "assets/google-translate-demo-18b353c02fad15e15e084f0bf1ed2450.webm";